//

import { ModuleLayout } from '@/components/reusable_components/next'
import { CommissionCreate, CommissionList, CommissionShow } from '@/views/commissions'

//
export default {
    path: 'commissions',
    component: ModuleLayout,
    children: [
        {
            path: 'create',
            name: 'commission_create',
            component: CommissionCreate,
            meta: {
                title: 'Crear comisión'
            },
        },
        {
            path: '',
            name: 'commission_list',
            component: CommissionList,
        },
        {
            path: ':id',
            name: 'commission_show',
            component: CommissionShow,
            meta: {
                title: 'Detalle de la comisión'
            },
        },
    ],
    meta: {
        title: 'Comisiones'
    },
}